import api from '../api'
import { timestamp } from '../../lib/misc'

export default (resource) => ({
  state: {
    ids: [],
    items: {},
  },
  getters: {
    getById: (state) => (id) => state.items[id],
    getArray: (state) => state.ids.map((id) => state.items[id]),
    getIds: (state) => state.ids,
    getUpdatedTimestamp: () => ({ updated_at: timestamp() }),
    getDeletedTimestamp: () => ({ deleted_at: timestamp() }),
  },
  mutations: {
    CLEAR(state) {
      state.ids.splice(0)
      state.items = {}
    },
    SET_ITEMS(state, { data }) {
      state.ids = data.map((e) => e.id)
      state.items = data.reduce((obj, cur) => ({ ...obj, [cur.id]: cur }), {})
    },
    APPEND_ITEMS(state, { data }) {
      state.ids = [...state.ids, ...data.map((e) => e.id)]
      state.items = {
        ...state.items,
        ...data.reduce((obj, cur) => ({ ...obj, [cur.id]: cur }), {}),
      }
    },
    SET_OR_UPDATE_ITEM(state, { data }) {
      if (!data) return
      if (state.ids.includes(data.id)) {
        state.items[data.id] = data
      } else {
        state.items[data.id] = data
        state.items = { [data.id]: data, ...state.items }
        state.ids.unshift(data.id)
      }
    },
    REMOVE_ITEM(state, id) {
      state.ids = state.ids.filter((e) => e !== id)
      delete state.items[id]
    },
  },
  actions: {
    async readCollection({ commit, getters }, { append = false } = {}) {
      try {
        const queryString = getters.queryString ? getters.queryString : ''
        const { data } = await api.get(`/${resource}${queryString}`)
        commit('SET_META_DATA', data)
        if (append) {
          commit('APPEND_ITEMS', data)
        } else {
          commit('SET_ITEMS', data)
        }
      } catch (err) {
        throw new Error('Ett problem uppstod när sidan hämtades')
      }
    },
    async read({ commit }, { type, id }) {
      const url = type ? `/${resource}/${type}/${id}` : `/${resource}/${id}`
      const { data } = await api.get(url)
      commit('SET_OR_UPDATE_ITEM', data)
      return data.data
    },
    async update({ commit, getters, rootGetters }, payload) {
      try {
        const updateData = {
          ...getters.getUpdatedTimestamp,
          updated_by: rootGetters['auth/currentUserAdminId'],
        }
        const { id } = payload
        const url = `/${resource}/${id}`
        const { data } = await api.put(url, { ...payload, ...updateData })
        commit('SET_OR_UPDATE_ITEM', data)
        return data
      } catch (err) {
        throw new Error('Ett problem uppstod när sidan uppdaterads')
      }
    },
    async create({ commit, getters, rootGetters }, payload) {
      try {
        const updateData = {
          ...getters.getUpdatedTimestamp,
          updated_by: rootGetters['auth/currentUserAdminId'],
        }
        const url = `/${resource}`
        const { data } = await api.post(url, { ...payload, ...updateData })
        commit('SET_OR_UPDATE_ITEM', data)
        return data
      } catch (err) {
        throw new Error('Ett problem uppstod när sidan uppdaterads')
      }
    },
    async delete({ commit, getters, rootGetters }, payload) {
      try {
        const { id } = payload
        const updateData = {
          ...getters.getUpdatedTimestamp,
          ...getters.getDeletedTimestamp,
          updated_by: rootGetters['auth/currentUserAdminId'],
        }
        const url = `/${resource}/${id}`
        const { data } = await api.delete(url, { ...payload, ...updateData })
        commit('REMOVE_ITEM', id)
        return data
      } catch (err) {
        throw new Error('Ett problem uppstod när sidan uppdaterads')
      }
    },
  },
})
